import * as React from 'react';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

interface MainContainerProps {
    children: React.ReactNode;
    isMobile: boolean;
    isSidebarExpand: boolean;
}

const MainContainer = ({
    children,
    isMobile,
    isSidebarExpand
}: MainContainerProps) => {
    const sizePushed = isSidebarExpand ? '250px' : '65px';
    const isMobileStyles = {
        width: isMobile && '100%',
        marginLeft: isMobile && '0',
        marginTop: isMobile && '65px'
    };
    const desktopStyles = {
        width: `calc(100% - ${sizePushed})`,
        marginLeft: sizePushed
    };
    return (
        <div
            className="main-container"
            style={isMobile ? isMobileStyles : desktopStyles}
        >
            <div className="main-container-wrapper">{children}</div>
            <div
                style={{ position: 'absolute', bottom: '10px', right: '20px' }}
            >
                <a
                    className="by-logo"
                    target="_blank"
                    rel="noreferrer"
                    href="https://nexxt.in"
                >
                    <img
                        style={{ maxWidth: '200px' }}
                        src={`${STATIC_STORAGE_URL}/img/powered_by_nexxt_intelligence_inca.png`}
                    />
                </a>
            </div>
        </div>
    );
};

export default MainContainer;
